import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M266.647 83.816H.293V50.522h266.354zm0 83.236H.293v33.294h266.354zM.293 316.876h149.824v-33.294H.293zM499.707 0v128.995L366.53 174.776v241.988c0 45.882-44.801 83.236-99.883 83.236s-99.883-37.354-99.883-83.236c0-45.887 44.801-83.235 99.883-83.235a111.25 111.25 0 0 1 66.589 21.367V55.141zM333.236 416.759c0-27.53-29.864-49.941-66.589-49.941-36.73 0-66.588 22.411-66.588 49.941s29.858 49.941 66.588 49.941c36.725 0 66.589-22.411 66.589-49.941M466.413 46.111 366.53 79.198v60.366l99.883-34.338z" }, null, -1)
  ])))
}
export default { render: render }